import loader from '../core/loader'
import env from '../core/env'

const SHARE_SDK = '//static.udache.com/share_sdk/0.0.5/shareSDK.min.js'
const _alipayMpSDK = 'https://appx/web-view.min.js'
const isMqq = env.is('mqq')
const isWechat = env.is('weixin')
const isAlipay = env.is('alipay')

function getPx (num) {
  let radio = document.documentElement.clientWidth / 750
  return `${num * radio}px`
}

export function showShareShadow (conf) {
  const shadowImg = conf.shadowImg || '//dpubstatic.udache.com/static/dpubimg/0e3e87f7-215c-48c2-9320-26577ad72bd2.png'
  const { isMiniAppEnv } = conf
  const $dom = document.createElement('div')
  $dom.style.position = 'fixed'
  $dom.style.width = '100%'
  $dom.style.height = '100%'
  $dom.style.left = '0'
  $dom.style.top = '0'
  $dom.style.backgroundColor = 'rgba(0,0,0,.6)'
  $dom.style.zIndex = 10000
  $dom.style.backgroundImage = `url(${shadowImg})`
  $dom.style.backgroundRepeat = 'no-repeat'
  $dom.style.backgroundSize = `${getPx(270)} auto`
  $dom.style.backgroundPositionY = '0'
  if (isMiniAppEnv) {
    $dom.style.backgroundPositionX = getPx(650 - 270)
  } else {
    $dom.style.backgroundPositionX = getPx(750 - 270)
  }
  setTimeout(() => {
    // 延时300ms后设置onclick方法，避免移动端点击穿透
    $dom.onclick = () => {
      document.body.removeChild($dom)
    }
  }, 300)
  document.body.appendChild($dom)
}

export function setShare (cfg) {
  if (isMqq) {
    return
  }
  loader.sdkReady('shareSDK', SHARE_SDK, sdk => {
    sdk.setShare(cfg)
  })
}

export function invokeShare (cfg) {
  if (isMqq || isWechat || isAlipay) {
    return showShareShadow(cfg)
  }
  loader.sdkReady('shareSDK', SHARE_SDK, sdk => {
    sdk.invokeShare(cfg)
  })
}

export function wx (fn) {
  loader.sdkReady('shareSDK', SHARE_SDK, sdk => {
    sdk.wx(fn)
  })
}

export function alipay (fn) {
  loader.sdkReady('shareSDK', SHARE_SDK, sdk => {
    sdk.alipay(fn)
  })
}

export function alipayMp (fn) {
  loader.sdkReady('alipayMp', _alipayMpSDK, sdk => {
    fn()
  })
}
